import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './ArticleTitleDashVariant.module.css';

const ArticleTitleDashVariant = () => {
  const { articleTitleDashVariant } = useSearchParamOrDefaultProps();

  return (
    <article className={styles.articleTitleDashVariantWrapper}>
      <div className={styles.dash}></div>
      <div className={styles.articleTitleDashVariantTitle}>
        {articleTitleDashVariant}
      </div>
      <div className={styles.dash}></div>
    </article>
  );
};

ArticleTitleDashVariant.displayName = 'ArticleTitleDashVariant';

export default ArticleTitleDashVariant;
